import React, { Component } from 'react';
import * as $ from 'jquery';
import { GENDER } from './ProfileContainer.js';
import { translate } from 'react-i18next';
import {
  validateIsDate,
  validateIsAdult,
} from "../../helpers/validateInput";
import Input from '../../components/Input/index.jsx';
import background from '../../images/cowork.jpeg';
import { Link } from 'react-router-dom';

class UserProfile extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  slugRegex = /^[A-Za-z0-9.-]+$/;
  validateSlugBlur = (e) => {
    const v = e.target.value || '';
    // Si no está vacío y NO cumple el patrón, alerta
    if (v !== '' && !this.slugRegex.test(v)) {
      const t = this.props.t;
      const msg = 'Campo no válido. Usa solo letras, números, puntos (.) y guiones (-).';
      alert(msg);
      e.target.focus();
      e.target.select();
    }
  };

  handleInvalid = (e) => {
    e.preventDefault();
    const t = this.props.t;
    const msg = 'Campo no válido. Usa solo letras, números, puntos (.) y guiones (-).';
    alert(msg);
  };
  
  componentDidMount() {
    $('#birthdate').datepicker({
      dateFormat: 'dd/mm/yy',
      changeMonth: true,
      changeYear: true,
      onSelect: (d, i) => {
        if (d !== i.lastVal) {
          this.props.handleBirthdateChange(d);
        }
      }
    });
    $('#btnEdit').click();
  }

  getInitState = () => {
    return { isEditing: false };
  }

  handleCancelClick = () => {
    this.setState({ isEditing: false });
    this.props.handleCancelClick();
  }

  handleEditClick = () => {
    this.setState({ isEditing: true });
  }

  handlePasswordClick = (event) => {

  }

  handleProfileSubmit = (event) => {
    event.preventDefault();
    const { user } = this.props;
  
    if (!validateIsDate(user.birthdate)) {
      alert("La fecha de nacimiento no es válida (usa DD/MM/YYYY)");
      return;
    }
  
    if (!validateIsAdult(user.birthdate)) {
      alert("Debes ser mayor de 18 años");
      return;
    }
  
    this.setState({ isEditing: false });
    this.props.handleProfileSubmit(event);
  };
  
  render() {
    const isEditing = this.state.isEditing;
    const user = this.props.user;
    const profile = user
    const { t } = this.props;

    return (
      <div className="content-resvations">
        <div className="container-resvations">
          <div className="row">
            <div className="col-md-6 col-md-push-6 col-lg-4 col-lg-push-8 text-center">
              <div className="content-profile">
                <div className="container-profile">
                  <div className="panel card">
                    <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + background + "')" }}>
                      <a onClick={() => $('#chooserProfilePortada').click()}>
                        <button className="change_portada">
                          <i className="fa fa-camera" aria-hidden="false"></i>
                        </button>
                      </a>
                    </div>

                    <div className="card-panel-body">
                      <div className="profile">
                        <a onClick={() => $('#chooserProfile').click()}>
                          <div className="badge-wrapper">
                            <img
                              className="cover-img__image relative w-full h-full object-cover img-responsive"
                              alt={t('dashboard.profile.img_user')}
                              src={profile.picture}
                              loading="lazy" data-embed-id="cover-image" />
                          </div>
                        </a>
                      </div>
                      <div className="profile-description">
                        <div className="user-data">
                          <h5 className='second-span'># {profile.user_id}</h5>
                          <h4 className="subspan">
                            {profile.name + " " + profile.lastname}
                          </h4>
                          {
                            (profile.position && profile.company) && (
                              <h4 className='second-span'>{profile.position} @ {profile.company}</h4>
                            )
                          }
                          <div>
                            {profile.center && (
                              <h4 className='ioscentro'>
                                {profile.center.center_name}
                              </h4>
                            )}
                          </div>
                          <div className="user-description" style={{ textAlign: "left" }}>
                            {profile.description}
                          </div>
                        </div>
                        <div className="user-work-data-informacion">
                          <h4>{t('dashboard.profile.account_info')}</h4>
                          <section className="user-work-data">
                            <i className="fa-regular fa-envelope"></i>
                            <p>{profile.email
                              ? profile.email
                              : t('dashboard.profile.email_not_provided') 
                            }</p>
                          </section>
                          <section className="user-work-data">
                            <i className="fa-solid fa-phone"></i>
                            <p>{profile.phone
                              ? profile.phone
                              : t('dashboard.profile.phone_not_provided')
                            }</p>
                          </section>
                          {
                            profile.business_name && (
                              <section className="user-work-data">
                                <i className="fa-regular fa-building"></i>
                                <p>{profile.business_name}</p>
                              </section>
                            )
                          }
                          {
                            profile.member_id && profile.perfil_publico === "1" ? (
                              <section className="user-work-data">
                                <i className="fa-solid fa-id-badge"></i>
                                <p>{t('dashboard.conecctions.public')}</p>
                              </section>
                            ) : (
                              <section className="user-work-data">
                                <i className="fa-solid fa-id-badge"></i>
                                <p>{t('dashboard.conecctions.private')}</p>
                              </section>
                            )
                          }
                        </div>
                        <div className="user-work-data-informacion">
                          <h4>{t('dashboard.profile.contact_info')}</h4>
                          {
                            profile.contact_email && (
                              <section className="user-work-data">
                                <i className="fa-solid fa-at"></i>
                                <p>{profile.contact_email}</p>
                              </section>
                            )
                          }
                          <div className="user-work-data">
                            <i className="fa fa-facebook-official" aria-hidden="true"></i>
                            <Link className="img-responsive redes" to={
                              profile.perfil_facebook ? profile.perfil_facebook : "/profile/edit/user"
                            }>
                              <p>
                                {profile.perfil_facebook
                                  ? profile.perfil_facebook
                                  : t('dashboard.profile.not_provided')
                                }
                              </p>
                            </Link>
                          </div>

                          <div className="user-work-data">
                            <i className="fa fa-instagram"></i>
                            <Link className="img-responsive redes" to={
                              profile.perfil_Instragram ? profile.perfil_Instragram : "/profile/edit/user"
                            }>
                              <p>
                                {profile.perfil_Instragram
                                  ? profile.perfil_Instragram
                                  : t('dashboard.profile.not_provided')
                                }
                              </p>
                            </Link>
                          </div>

                          <div className="user-work-data">
                            <i className="fa fa-linkedin"></i>
                            <Link className="img-responsive redes" to={
                              profile.perfilLinkedin ? profile.perfilLinkedin : "/profile/edit/user"
                            }>
                              <p>
                                {profile.perfilLinkedin
                                  ? profile.perfilLinkedin
                                  : t('dashboard.profile.not_provided')
                                }
                              </p>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="profile-contact">
                        <section className={isEditing ? "hidden" : ""}>
                          <div className="form-group col-md-12">
                            <button
                              className="btn btn-primary btn-full-width"
                              onClick={this.handleEditClick}
                              type="button"
                              id="btnEdit">
                              {t('dashboard.profile.btn_edit')}
                            </button>
                          </div>
                        </section>
                        <div className="form-group col-md-12">
                          <button
                            className="btn btn-default btn-full-width"
                            onClick={this.props.handlePasswordClick}
                            type="button"
                            id="btnEdit">
                            {t('dashboard.profile.btn_password')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-md-pull-6 col-lg-8 col-lg-pull-4">
              <div className="panel panel-default">
                <div className="panel-body">
                  <form method="post" onSubmit={this.handleProfileSubmit}>
                    <div className="">
                      <h4 className="ioscentro">{t('dashboard.profile.heading_user')}</h4>
                      {!this.props.user.name || !this.props.user.lastname || !this.props.user.phone || this.props.user.birthdate === "Invalid date" ? (
                        <h4 style={{ color: "red" }}>Favor de Completar los Datos Faltantes</h4>
                      ) : null}
                      {this.props.user.ios_express === "1" ? (
                        <h4 style={{ color: "red" }}>Favor de Cambiar la Contraseña</h4>
                      ) : null}

                    </div>
                    <fieldset>
                      <input
                        className="hidden"
                        id="chooserProfile"
                        onChange={this.props.handleProfilePicture}
                        type="file" />
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="name">
                              {t('dashboard.profile.label_name')}
                              {!this.props.user.name ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <Input
                              className="form-control"
                              disabled={!isEditing}
                              id="name"
                              required
                              onChange={this.props.handleNameChange}
                              placeholder={t('dashboard.profile.holder_name')}
                              type="text"
                              value={user.name} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="lastname">
                              {t('dashboard.profile.label_lastname')}
                              {!this.props.user.lastname ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <Input
                              className="form-control"
                              disabled={!isEditing}
                              id="lastname"
                              required
                              onChange={this.props.handleLastnameChange}
                              placeholder={t('dashboard.profile.holder_lastname')}
                              type="text"
                              value={user.lastname} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="contactEmail">
                              {t('dashboard.profile.label_cemail')}
                            </label>
                            <Input
                              className="form-control"
                              disabled={!isEditing}
                              id="contactEmail"
                              onChange={this.props.handleContactEmail}
                              placeholder={t('dashboard.profile.holder_cemail')}
                              type="email"
                              value={user.contact_email} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="phone">
                              {t('dashboard.profile.label_phone')}
                              {!this.props.user.phone ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <Input
                              className="form-control"
                              disabled={!isEditing}
                              id="phone"
                              required
                              onChange={this.props.handlePhoneChange}
                              placeholder={t('dashboard.profile.holder_phone')}
                              type="tel"
                              value={user.phone} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="birthdate">
                              {t('dashboard.profile.label_birthdate')}
                              {this.props.user.birthdate === "Invalid date" ? (<a style={{ color: "red" }}>*</a>) : null}
                            </label>
                            <input
                              autoComplete="off"
                              className="form-control"
                              disabled={!isEditing}
                              id="birthdate"
                              onChange={(e) => this.props.handleBirthdateChange(e.target.value)}
                              placeholder={t('dashboard.profile.holder_birthdate')}
                              type="text"
                              value={user.birthdate} />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="gender">
                              {t('dashboard.profile.label_gender')}
                            </label>
                            <select
                              className="form-control"
                              disabled={!isEditing}
                              id="gender"
                              onChange={this.props.handleGenderChange}
                              value={user.gender}>
                              <option value={GENDER.MALE}>{t('dashboard.profile.gender_male')}</option>
                              <option value={GENDER.FEMALE}>{t('dashboard.profile.gender_female')}</option>
                              <option value={GENDER.OTHER}>{t('dashboard.profile.gender_other')}</option>
                            </select>
                          </div>
                        </div>
                        <section className="col-md-12">
                          <h4 className="ioscentro">{t('dashboard.profile.heading_company')}</h4>
                        </section>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="position">
                              {t('dashboard.profile.label_position')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="position"
                              onChange={this.props.handlePositionChange}
                              placeholder={t('dashboard.profile.holder_position')}
                              type="text"
                              value={user.position} />
                          </div>
                        </div>                        
                        
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label htmlFor="business">
                              {t('dashboard.profile.label_business')}
                            </label>
                            <select
                              className="form-control"
                              disabled={!isEditing}
                              id="business"
                              onChange={this.props.handleBusinessChange}
                              value={user.business_id}>
                              <option value="">{t('dashboard.profile.holder_select')}</option>
                              {this.props.business.map((object, index) =>
                                <option key={index} value={object.id}>{object.name}</option>
                              )}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="description">
                              {t('dashboard.profile.label_description')}
                            </label>
                            <textarea
                              maxLength="250"
                              className="form-control"
                              disabled={!isEditing}
                              id="description"
                              onChange={this.props.handleDescriptionChange}
                              placeholder={t('dashboard.profile.holder_description')}
                              rows="3"
                              value={user.description} />
                          </div>
                        </div>
                        <section className="col-md-12">
                          <h4 className="ioscentro">
                            {t('dashboard.profile.heading_social')}
                          </h4>
                        </section>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="linkedin">
                              {t('dashboard.profile.LinkedIn')}
                            </label>
                            <Input
                              className="form-control"
                              disabled={!isEditing}
                              id="linkedin"
                              onChange={this.props.handleProfileLinkedinChange}
                              placeholder={t('dashboard.profile.LinkedIn')}
                              value={user.perfilLinkedin} />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="position">
                              {t('dashboard.profile.Instragram')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="position"
                              onChange={this.props.handleProfileInstagramChange}
                              placeholder={t('dashboard.profile.Instragram')}
                              type="text"
                              value={user.perfil_Instragram} />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="phone">
                              {t('dashboard.profile.Facebook')}
                            </label>
                            <input
                              className="form-control"
                              disabled={!isEditing}
                              id="phone"
                              onChange={this.props.handleProfileFacebookChange}
                              placeholder={t('dashboard.profile.Facebook')}
                              type="tel"
                              value={user.perfil_facebook} />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="interests">
                              {t('dashboard.profile.label_interests')}
                            </label>
                            <textarea
                              className="form-control"
                              disabled={!isEditing}
                              id="interests"
                              onChange={this.props.handleInterestsChange}
                              placeholder={t('dashboard.profile.holder_interests')}
                              rows="3"
                              value={user.interests} />
                          </div>
                        </div>
                      </div>
                      {/* <div className="form-group">
                        <button
                          className="btn btn-link"
                          data-target="#moreFields"
                          data-toggle="collapse"
                          type="button">
                          {t('dashboard.profile.btn_more')}&nbsp;
                          <span className="caret" />
                        </button>
                      </div>
                      <div className="collapse" id="moreFields">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="gender">
                                {t('dashboard.profile.label_gender')}
                              </label>
                              <select
                                className="form-control"
                                disabled={!isEditing}
                                id="gender"
                                onChange={this.props.handleGenderChange}
                                value={user.gender}>
                                <option value={GENDER.MALE}>{t('dashboard.profile.gender_male')}</option>
                                <option value={GENDER.FEMALE}>{t('dashboard.profile.gender_female')}</option>
                                <option value={GENDER.OTHER}>{t('dashboard.profile.gender_other')}</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label htmlFor="interests">
                                {t('dashboard.profile.label_interests')}
                              </label>
                              <textarea
                                className="form-control"
                                disabled={!isEditing}
                                id="interests"
                                onChange={this.props.handleInterestsChange}
                                placeholder={t('dashboard.profile.holder_interests')}
                                rows="3"
                                value={user.interests} />
                            </div>
                          </div>

                        </div>
                      </div> */}
                      {this.props.user.ios_express === "1" ? (
                        <button
                          className="btn btn-primary btn-full-width"
                          type="submit">
                          {t('dashboard.profile.btn_save')}
                        </button>
                      ) : (
                        <section className={isEditing ? "content-buttons" : "hidden"}>
                          <button
                            className="btn btn-primary btn-full-width"
                            type="submit">
                            {t('dashboard.profile.btn_save')}
                          </button>
                          <button
                            className="btn btn-default btn-full-width"
                            onClick={this.handleCancelClick}
                            type="button">
                            {t('dashboard.profile.btn_cancel')}
                          </button>
                        </section>
                      )}
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      
    );
  }
}

export default translate('common')(UserProfile);



// WEBPACK FOOTER //
// ./src/dashboard/profile/UserProfile.js